import { Component, HostBinding, OnInit, OnDestroy, HostListener, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Generic } from './generic.model';
import { GenericService } from './generic.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { Page } from '../shared/navigation/pages.model';
import { Subscription, take } from 'rxjs';
import { environment } from '../../environments/environment';
import { utils } from '../shared/helpers/utils';

@Component({
  selector: 'app-generic',
  templateUrl: 'generic.component.html',
  styleUrls: ['generic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class GenericComponent implements OnInit, OnDestroy {
 public cdn = environment.cdn;
 public path_list = '/';
 public path_details = '/';
 public pageTitle: string;
 public pageContent: string;
 public generics: Generic[];
 public children: Page[] = [];
 public currentUrl = '';
 public count = 0;
 public pageSize = 12;
 public page = 0;
 public query: any = {page: 1, pagesize: 12};
 public sub: Subscription = null;
 public sub1: Subscription = null;
 public sub2: Subscription = null;
 public categories: Page[] = [];
 public selected: number;
 public links = ['First', 'Second', 'Third'];
 public catsVisible = 'expanded';

 @HostListener('window:resize', ['$event'])
    onResize(event) {
      if (event.target.innerWidth < 599) {
        this.catsVisible = 'collapsed';
      } else {
        this.catsVisible = 'expanded';
      }
  }

 constructor(private router: Router, private route: ActivatedRoute, private navigationService: NavigationService,
             private genericService: GenericService, private cdr: ChangeDetectorRef) {

    this.path_details = this.router.config.find(r => r.data?.module === 'GenericDetailsModule')?.data.path || '/';  
    this.path_list = this.router.config.filter(r => r?.data?.module === 'GenericModule').reduce((prev, curr) => (prev.data.level < curr.data.level) ? prev : curr)?.path || '/';
 }

 ngOnInit() {

  this.currentUrl = this.router.url;
  this.pageTitle = this.route.snapshot.data.name;
  this.pageContent = this.route.snapshot.data.content;

  this.sub = this.route.queryParamMap.subscribe(params => {
    this.query['page'] = params.get('page') || 1;
    this.query['pagesize'] = params.get('pagesize') || 12;
    this.getGenerics();
  });

 }

 trackGenericBy(index, generic) {
   return index;
 }

 onPage(event: any) {
  this.query['page'] = event.pageIndex + 1;
  this.router.navigate([this.path_list], { queryParams: this.query });
}

getGenerics() {
  this.genericService.items(this.query).pipe(take(1)).subscribe(generics => {
    this.generics = generics.items || [];
    this.count = generics.pages.totalItemCount || 0;
    this.cdr.markForCheck();
  });
}

 ngOnDestroy() {
   if (this.sub) {
     this.sub.unsubscribe();
   }
   if (this.sub1) {
     this.sub1.unsubscribe();
   }
   if (this.sub2) {
     this.sub2.unsubscribe();
   }
 }

}
